import React, { useEffect } from "react";
import { Box, styled } from "@material-ui/core";
import Place from "components/repairFunnel/assets/place.svg";
import H4 from "components/design-system/atoms/Typography/H4";
import BodyLarge from "components/design-system/atoms/Typography/BodyLarge";
import { pushHomeRepairZoneNotServed } from "lib/gtm";

const Content = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
    textAlign: "left",
  },
}));

type HomeRepairZoneNotServedProps = {
  productType: string;
  postalCode: string;
};

const HomeRepairZoneNotServed: React.FunctionComponent<HomeRepairZoneNotServedProps> = ({
  productType,
  postalCode,
}) => {
  useEffect(() => {
    pushHomeRepairZoneNotServed(postalCode, productType);
  });
  return (
    <Content>
      <Box padding={3}>
        <Place />
      </Box>
      <Box padding={3}>
        <Box mb={3}>
          <H4 color="secondary">Nous ne réparons pas encore ici !</H4>
        </Box>
        <Box mb={3}>
          <BodyLarge color="secondary">
            On souhaite rendre la réparation accessible à tous alors on y travaille !
          </BodyLarge>
        </Box>
      </Box>
    </Content>
  );
};

export default HomeRepairZoneNotServed;
